module.exports = __webpack_public_path__ + "static/media/IT1000.67bc2b6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/plasticProducts/IT1000.jpg
// module id = 242
// module chunks = 0